/** @jsx CanvaSX */
import { CanvaSX, type MountedObject } from '@lib/canvasx/canvasx';
import {
  EditableText,
  type EditableTextProps,
} from '../../canvasx/EditableText';
import { FlexRow, type FlexRowProps } from '@lib/canvasx/components/FlexRow';
import { type IconData } from '../../types';
import { SPACER_3 } from '../../utils/style';
import { SvgIcon, getIconSvg } from './SvgIcon';

export type TextWithIconProps = {
  key?: string;
  iconLeft?: IconData;
  iconRight?: IconData;
  cursor?: MountedObject['cursor'];
  iconColor?: string;
  textBorder?: BorderStruct;
  textPadding?: SpacingType;
  iconSize?: number;
  iconOpacity?: number;
} & Partial<ShapeStruct> &
  Partial<EditableTextProps> &
  Partial<FlexRowProps>;

export const TextWithIcons: CanvaSXFC<TextWithIconProps> = function (props) {
  const {
    x,
    y,
    children,
    width,
    border,
    padding,
    margin,
    borderRadius = 0,
    iconLeft,
    iconRight,
    color,
    iconColor = color,
    fill,
    key,
    textKey,
    textEditing,
    gap = SPACER_3,
    size,
    iconSize = size,
    opacity,
    bold,
    textBorder,
    textPadding,
    maxRows = 1,
    minWidth,
    iconOpacity = 1,
    onChange,
    setRenderedDimensions,
  } = props;

  return (
    <FlexRow
      x={x}
      y={y}
      key={key}
      border={border}
      borderRadius={borderRadius}
      width={width}
      fill={fill}
      padding={padding}
      setRenderedDimensions={setRenderedDimensions}
      verticalAlignment='center'
      gap={gap}
      maxRows={maxRows}
    >
      {iconLeft && getIconSvg(iconLeft) && (
        <SvgIcon
          iconData={iconLeft}
          iconFill={iconColor}
          padding={textPadding}
          opacity={iconOpacity}
          size={iconSize}
        />
      )}

      {Array.isArray(children) &&
        children.length > 0 &&
        children.some(child => child !== null) && (
          <EditableText
            textKey={textKey}
            color={color}
            onChange={onChange}
            margin={margin}
            textEditing={textEditing}
            size={size}
            opacity={opacity}
            bold={bold}
            flexGrow
            border={textBorder}
            padding={textPadding}
            minWidth={minWidth}
          >
            {children}
          </EditableText>
        )}

      {iconRight && getIconSvg(iconRight) && (
        <SvgIcon
          iconData={iconRight}
          iconFill={iconColor}
          padding={textPadding}
          opacity={opacity}
          size={iconSize}
        />
      )}
    </FlexRow>
  );
};
